import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@savvy-kit/components/select';

const DEFAULT_PAGE_SIZES = [5, 10, 25, 50];

type PageSizeSelectProps = {
  readonly value: number;
  readonly onChange: (pageSize: number) => void;
  readonly options?: readonly number[];
};

export function PageSizeSelect({ value, onChange, options = DEFAULT_PAGE_SIZES }: PageSizeSelectProps) {
  return (
    <Select value={String(value)} onValueChange={(next) => onChange(Number(next))}>
      <SelectTrigger size="sm" className="min-w-20">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((size) => (
          <SelectItem key={size} value={String(size)}>
            {size}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
